import { render, staticRenderFns } from "./AdminBusinessHolidaySetting.vue?vue&type=template&id=c12d3eca&scoped=true"
import script from "./AdminBusinessHolidaySetting.vue?vue&type=script&lang=js"
export * from "./AdminBusinessHolidaySetting.vue?vue&type=script&lang=js"
import style0 from "./AdminBusinessHolidaySetting.vue?vue&type=style&index=0&id=c12d3eca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12d3eca",
  null
  
)

export default component.exports